import Swiper from 'swiper/bundle';

export default function initializeBlockIconBoxes() {
    document.querySelectorAll('.block-icon-boxes').forEach(function(block) {
        new BlockIconBoxes(block);
    });
}

class BlockIconBoxes {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        const slider = this.block.querySelector('.block-icon-boxes__slider:not(.block-icon-boxes__slider--disabled)');
        const swiper = new Swiper(slider, {
            slidesPerView: "auto",
            grabCursor: true,
            speed: 1000,
            // loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    }
}
